var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoginPassShowedSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon login-pass showed",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 4C6.179 4 2.714 6.104.156 9.522a.804.804 0 000 .952C2.714 13.896 6.18 16 10 16c3.821 0 7.286-2.104 9.844-5.522a.804.804 0 000-.952C17.286 6.104 13.82 4 10 4zm.26 9.992a4.003 4.003 0 01-4.252-4.253 4.009 4.009 0 013.731-3.73 4.002 4.002 0 014.253 4.252 4.021 4.021 0 01-3.731 3.73zm-.132-1.996a1.997 1.997 0 01-2.124-2.124 2.009 2.009 0 011.868-1.868 1.997 1.997 0 012.124 2.124 2.01 2.01 0 01-1.868 1.868z"
  })));
}

export default SvgLoginPassShowedSv;